// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "default/assets/" + {"104":"4f0566cd5e360d9ce657","168":"0cb0ef132b5db824bf74","303":"4ec62272f518f15fe7f6","411":"57d636eaf88b20a50947","619":"839b4bfd5db69c6c7527","956":"4563788cb74fa9968898"}[chunkId] + "." + chunkId + ".js";
};